<template>
    <div>
        <div class="p-grid">
            <app-menu-bar title="Form Edit Organisasi Pengadaan" back_url="organisasi_pengadaan"/>
            <Card class="p-fluid">
                <template #content>
                    <div class="field grid">
                        <label for="paket_pengadaan_id" class="col-12 mb-2 md:col-2 md:mb-0">Paket Pengadaan</label>
                        <div class="col-12 md:col-10">
                            <InputText id="paket_pengadaan_id" type="text" :class="{'p-invalid' : errors.paket_pengadaan_id}" v-model="form.paket_pengadaan_id" />
                            <small v-if="errors.paket_pengadaan_id" id="name-help" class="p-error">Paket Pengadaan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="ppk_id" class="col-12 mb-2 md:col-2 md:mb-0">Pejabat Pembuat Komitmen</label>
                        <div class="col-12 md:col-10">
                            <InputText id="ppk_id" type="text" :class="{'p-invalid' : errors.ppk_id}" v-model="form.ppk_id" />
                            <small v-if="errors.ppk_id" id="name-help" class="p-error">Pejabat Pembuat Komitmen Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="ttpp_id" class="col-12 mb-2 md:col-2 md:mb-0">Tim Teknik Perencanaan Pengadaan</label>
                        <div class="col-12 md:col-10">
                            <InputText id="ttpp_id" type="text" :class="{'p-invalid' : errors.ttpp_id}" v-model="form.ttpp_id" />
                            <small v-if="errors.ttpp_id" id="name-help" class="p-error">Tim Teknik Perencanaan Pengadaan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="ttpk_id" class="col-12 mb-2 md:col-2 md:mb-0">Tim Teknis Pelaksanaan Kontrak</label>
                        <div class="col-12 md:col-10">
                            <InputText id="ttpk_id" type="text" :class="{'p-invalid' : errors.ttpk_id}" v-model="form.ttpk_id" />
                            <small v-if="errors.ttpk_id" id="name-help" class="p-error">Tim Teknis Pelaksanaan Kontrak Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="pp_id" class="col-12 mb-2 md:col-2 md:mb-0">Pejabat Pengadaan</label>
                        <div class="col-12 md:col-10">
                            <InputText id="pp_id" type="text" :class="{'p-invalid' : errors.pp_id}" v-model="form.pp_id" />
                            <small v-if="errors.pp_id" id="name-help" class="p-error">Pejabat Pengadaan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="pphp_id" class="col-12 mb-2 md:col-2 md:mb-0">Pejabat Penerima Hasil Pekerjaan</label>
                        <div class="col-12 md:col-10">
                            <InputText id="pphp_id" type="text" :class="{'p-invalid' : errors.pphp_id}" v-model="form.pphp_id" />
                            <small v-if="errors.pphp_id" id="name-help" class="p-error">Pejabat Penerima Hasil Pekerjaan Wajib Diisi</small>
                        </div>
                    </div>
                </template>  
                <template #footer>
                    <div class="field grid">
                        <div class="col-offset-2">
                            <Button icon="pi pi-send" label="Simpan" class="p-button p-button-primary ml-2" @click="submitForm()"/>
                        </div>
                    </div>
                </template>
            </Card>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import JetLabel from "@/Jetstream/Label";
import { Inertia } from '@inertiajs/inertia'
import { useForm } from "@inertiajs/inertia-vue3"
import AppMenuBar from "@/Components/AppMenuBar.vue";
import DeleteDialog from "@/Components/DeleteDialog";
import DropdownWilayah from "@/Components/DropdownWilayah.vue";
import MapInput from "@/Components/MapInput.vue";
import { FilterMatchMode } from "primevue/api";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import AutoComplete from 'primevue/autocomplete';
import Button from "primevue/button";
import Calendar from 'primevue/calendar';
import Card from "primevue/card";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import Dialog from 'primevue/dialog';
import Divider from "primevue/divider";
import Dropdown from 'primevue/dropdown';
import FileUpload from 'primevue/fileupload';
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Menubar from "primevue/menubar";
import MultiSelect from 'primevue/multiselect';
import OverlayPanel from 'primevue/overlaypanel';
import Password from "primevue/password";
import ProgressBar from 'primevue/progressbar';
import RadioButton from 'primevue/radiobutton';
import Textarea from 'primevue/textarea';
import pdfvuer from 'pdfvuer'
import SelectPPHPTender from "./partials/SelectPPHPTender.vue";
import SelectTTPP from "./partials/SelectTTPP.vue";
import SelectTTPK from "./partials/SelectTTPK.vue";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppMenuBar,
        JetLabel,
        DeleteDialog,
        DropdownWilayah,
        MapInput,
        Accordion,
        AccordionTab,
        AutoComplete,
        Button,
        Calendar,
        Card,
        Column,
        DataTable,
        Dialog,
        Divider,
        Dropdown,
        FileUpload,
        InputText,
        InputNumber,
        Menubar,
        MultiSelect,
        OverlayPanel,
        Password,
        ProgressBar,
        RadioButton,
        Textarea,
        pdf: pdfvuer,
        SelectPPHPTender,
        SelectTTPP,
        SelectTTPK,
    },
    props : {
        errors : Array,
        pengadaan_langsung : Boolean,
        adminkpbj : Boolean,
        paket_pengadaan : Object,
        daftar_pokja : Array,
        daftar_ppk : Array,
        daftar_pp : Array,
        daftar_pphp : Array,
        daftar_ttpp : Array,
        daftar_ttpk : Array,
    },
    data() {
        return { 
            nodes : null, 
            // selected_permission : [],
            expandedKeys : {}
        }
    },
    permissionService : null,
    props : {
        errors : Array,
        form : Array,
    },
    methods : {
        submitForm(){
            // alert(this.form)
            // this.form.permissions = this.selected_permission;
            Inertia.put(`/organisasi_pengadaan/${this.form.id}`, this.form);
        },
        console_log(param){
            console.log(param);
        },
    }
}
</script>
